import { StatusCodes } from "http-status-codes";
import { request } from "../api";
import { headers } from "../../../config/config";
import { MESSAGE } from "../../../constants/api/message";
import { AUTHORIZATION } from "../../../constants/api/auth";
import { VEBPlan } from "../../../@types/plan.types";
import { Plan_Name, VEB_Plan_Name } from "../../../@types/components/plan.types";

export type BenefitRecalculationPayloadType = {
	group_number: number;
	member_SSN: string;
	insured_SSN: string;
	termination_date: Date;
	termination_reason: string;
	type?: string;
	effective_date?: Date | string;
	plan_code?: string;
	plan_name?: Plan_Name | VEB_Plan_Name | string;
};

const { put } = request;
const { Authorization, Bearer } = AUTHORIZATION;

const initialRoute = "member";

// eslint-disable-next-line arrow-parens
export const benefitRecalculation = async (_payload: BenefitRecalculationPayloadType) => {
	try {
		const payload = JSON.stringify(_payload);
		const endpoint = `${initialRoute}/enrollment/benefit-recalculation`;
		const token = localStorage.getItem("@jwt");
		const response = await put(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			alert(message);
		} else {
			throw error;
		}
	}
};

// eslint-disable-next-line arrow-parens
export const benefitRecalculationAfterRemovingDependent = async (_payload: BenefitRecalculationPayloadType) => {
	try {
		const payload = JSON.stringify(_payload);
		const endpoint = `${initialRoute}/enrollment/benefit-recalculation-after-removing-dependent`;
		const token = localStorage.getItem("@jwt");
		const response = await put(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			alert(message);
		} else {
			throw error;
		}
	}
};
